// ======================================================================
// File Name       : ServiceGroupAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { MODE } from '../constants';
import {
  SERVICE_GROUP_GET_SERVICE_GROUP_NAME,
  SERVICE_GROUP_INIT_EDITING,
  SERVICE_GROUP_RECEIVE_EDITING_GROUP,
  SERVICE_GROUP_RECEIVE_EDITING_SERVICE,
  SERVICE_GROUP_RECEIVE_EDITING_SUPERUSER,
  SERVICE_GROUP_RECEIVE_LIST,
  SERVICE_GROUP_RECEIVE_SEARCH_CONDITION_SUPERUSER,
  SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SERVICE,
  SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SUPERUSER,
  SERVICE_GROUP_RECEIVE_SERVICE_RELATION,
  SERVICE_GROUP_RECEIVE_SUPERUSER_RELATION,
  SERVICE_GROUP_RESET_DATA
} from '../constants/ActionTypes';
import * as ModalIds from '../constants/ModalIds';
import * as modalActions from './ModalAction';
import * as serviceGroupRequests from './httpRequests/serviceGroup';

export function getServiceGroupList(param) {
  return (dispatch) => serviceGroupRequests.postServiceGroupGetList(param)
    .then((resData) => {
      const { recordNum, serviceGroupList } = resData;
      dispatch(receiveServiceGroupList(recordNum, serviceGroupList));
    });
}

function receiveServiceGroupList(recordNum, serviceGroupList) {
  return {
    type: SERVICE_GROUP_RECEIVE_LIST,
    recordNum,
    serviceGroupList,
  }
}

export function openServiceGroupRegisterDialog() {
  return (dispatch) => {
    dispatch(modalActions.openModal(ModalIds.SERVICE_GROUP_REGISTER_EDIT));
  };
}

export function getServiceGroupGetServiceRelation(serviceGroupSecernId) {
  // fetch servicegroup service relation
  const paramServiceRelation = {
    searchInfo: {
      serviceGroupSecernId,
    }
  }
  return (dispatch) => serviceGroupRequests.postServiceGroupGetServiceRelation(paramServiceRelation)
    .then((resdata) => {
      const { recordNum, serviceGroupRelationList } = resdata;
      dispatch(receivedServiceGroupGetServiceRelation(serviceGroupSecernId, recordNum, serviceGroupRelationList));
    });
}

function receivedServiceGroupGetServiceRelation(serviceGroupSecernId, recordNum, serviceGroupRelationList) {
  return {
    type: SERVICE_GROUP_RECEIVE_SERVICE_RELATION,
    serviceGroupSecernId,
    recordNum,
    serviceGroupRelationList,
  }
}

export function getServiceGroupGetSuperUserRelation(serviceGroupSecernId, superuserSecernId) {
  // fetch servicegroup service relation
  const paramSuperUserRelation = {
    searchInfo: {
      serviceGroupSecernId,
      superuserSecernId,
    },
  }
  return (dispatch) => serviceGroupRequests.postServiceGroupGetSuperUserRelation(paramSuperUserRelation)
    .then((resdata) => {
      const { recordNum, serviceGroupRelationList } = resdata;
      dispatch(receivedServiceGroupGetSuperUserRelation(serviceGroupSecernId, recordNum, serviceGroupRelationList));
    });
}

export function receivedServiceGroupGetSuperUserRelation(serviceGroupSecernId, recordNum, serviceGroupRelationList) {
  return {
    type: SERVICE_GROUP_RECEIVE_SUPERUSER_RELATION,
    serviceGroupSecernId,
    recordNum,
    serviceGroupRelationList,
  };
}

export function getServiceGroupServiceName(serviceGroupSecernId) {
  return {
    type: SERVICE_GROUP_GET_SERVICE_GROUP_NAME,
    serviceGroupSecernId,
  };
}

export function getServiceGroupDetail(serviceGroupSecernId) {
  return (dispatch) => {
    // reset init data
    dispatch(resetInitData());

    // fetch servicegroup  service group name
    dispatch(getServiceGroupServiceName(serviceGroupSecernId));

    const requests = [];
    // fetch servicegroup service relation
    requests.push(dispatch(getServiceGroupGetServiceRelation(serviceGroupSecernId)));

    // fetch servicegroup superuser relation
    requests.push(dispatch(getServiceGroupGetSuperUserRelation(serviceGroupSecernId, null)));

    Promise.all(requests).then(() => {
      dispatch(doInitServiceGroupEditing({ serviceGroupSecernId }));
    });
  };
}

export function deleteServiceGroup(serviceGroupSecernId) {
  return async (dispatch) => {
    const param = {
      editType: MODE.DELETE_MODE,
      serviceGroupInfo: {
        serviceGroupSecernId,
      },
    };

    await serviceGroupRequests.postServiceGroupEdit(param);
    dispatch(getServiceGroupList());
  };
}

function doInitServiceGroupEditing({ serviceGroupSecernId }) {
  return {
    type: SERVICE_GROUP_INIT_EDITING,
    serviceGroupSecernId,
  };
}

export function editingServiceGroup(payload) {
  return {
    type: SERVICE_GROUP_RECEIVE_EDITING_GROUP,
    payload,
  };
}

export function getServiceGroupServiceList(searchInfo) {
  return async (dispatch) => {
    const camelizeJson = await serviceGroupRequests.postServiceGetList(searchInfo);
    return dispatch(receiveServiceList(camelizeJson));
  };
}

function receiveServiceList(serviceInfo) {
  return {
    type: SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SERVICE,
    serviceInfo,
  };
}

export function editingServiceGroupService({ removedServiceCd, addedList = [], removedAll }) {
  return {
    type: SERVICE_GROUP_RECEIVE_EDITING_SERVICE,
    removedServiceCd,
    addedList,
    removedAll,
  };
}

export function getServiceGroupSuperUserList(param) {
  return async (dispatch) => {
    const camelizeJson = await serviceGroupRequests.postSuperUserGetList(param);
    const { startPosition } = param.searchInfo;
    const { recordNum, superuserList } = camelizeJson;
    return dispatch(receiveSuperUserList(startPosition, recordNum, superuserList));
  };
}

function receiveSuperUserList(startPosition, recordNum, superuserList) {
  return {
    type: SERVICE_GROUP_RECEIVE_SEARCH_RESULT_SUPERUSER,
    startPosition,
    recordNum,
    superuserList,
  };
}

export function editingServiceGroupSuperUser({ removedSecern, addedList = [], removedAll }) {
  return {
    type: SERVICE_GROUP_RECEIVE_EDITING_SUPERUSER,
    removedSecern,
    addedList,
    removedAll,
  };
}

export function editingSuperUserSearchCondition(payload) {
  return {
    type: SERVICE_GROUP_RECEIVE_SEARCH_CONDITION_SUPERUSER,
    payload,
  };
}

export function resetInitData() {
  return {
    type: SERVICE_GROUP_RESET_DATA,
  };
};

export function saveServiceGroup() {
  return async (dispatch, getState) => {
    const { serviceGroup, authed } = getState();
    const { userSecernId } = authed.authedUser.userInfo;
    const { serviceGroupName } = serviceGroup.editingServiceGroup;

    // Save service group info
    const paramServiceGroup = {
      editType: serviceGroup.editType,
      serviceGroupInfo: {
        serviceGroupSecernId: serviceGroup.editingServiceGroup.serviceGroupSecernId,
        serviceGroupName,
      },
    };

    const { serviceGroupSecernId } = await serviceGroupRequests.postServiceGroupEdit(paramServiceGroup);
    const {
      storedServiceGroupService,
      storedServiceGroupSuperUser,
      editingServiceGroupService,
      editingServiceGroupSuperUser,
    } = serviceGroup;

    // deleted services
    const deletedServices = Object.keys(storedServiceGroupService).reduce((acc, serviceCd) => {
      if (!editingServiceGroupService[serviceCd]) {
        acc.push(serviceCd);
      }
      return acc;
    }, []);

    // registered services
    const registeredServices = Object.keys(editingServiceGroupService).reduce((acc, serviceCd) => {
      if (!storedServiceGroupService[serviceCd]) {
        acc.push(serviceCd);
      }
      return acc;
    }, []);

    // deleted superusers
    const deletedSuperUsers = Object.keys(storedServiceGroupSuperUser).reduce((acc, userSecernId) => {
      if (!editingServiceGroupSuperUser[userSecernId]) {
        acc.push(userSecernId);
      }
      return acc;
    }, []);

    // registered superusers
    const registeredSuperUsers = Object.keys(editingServiceGroupSuperUser).reduce((acc, userSecernId) => {
      if (!storedServiceGroupSuperUser[userSecernId]) {
        acc.push(userSecernId);
      }
      return acc;
    }, []);

    // save service group service relation
    let paramServiceEditRelation = {};
    if (registeredServices.length > 0) {
      paramServiceEditRelation = {
        editType: MODE.NEW_MODE,
        serviceGroupInfo: {
          serviceGroupSecernId,
          serviceList: registeredServices,
        },
      };
      await serviceGroupRequests.postServiceGroupEditServiceRelation(paramServiceEditRelation);
    }

    if (deletedServices.length > 0) {
      paramServiceEditRelation = {
        editType: MODE.DELETE_MODE,
        serviceGroupInfo: {
          serviceGroupSecernId,
          serviceList: deletedServices,
        },
      };
      await serviceGroupRequests.postServiceGroupEditServiceRelation(paramServiceEditRelation);
    }

    // save service group superuser relation
    let paramSuperuserEditRelation = {};

    if (registeredSuperUsers.length > 0) {
      paramSuperuserEditRelation = {
        editType: MODE.NEW_MODE,
        serviceGroupInfo: {
          serviceGroupSecernId,
          superuserList: registeredSuperUsers,
        },
      };
      await serviceGroupRequests.postServiceGroupEditSuperUserRelation(paramSuperuserEditRelation);
    }

    if (deletedSuperUsers.length > 0) {
      paramSuperuserEditRelation = {
        editType: MODE.DELETE_MODE,
        serviceGroupInfo: {
          serviceGroupSecernId,
          superuserList: deletedSuperUsers,
        },
      };
      await serviceGroupRequests.postServiceGroupEditSuperUserRelation(paramSuperuserEditRelation);
    }

    dispatch(getServiceGroupList({}));
    dispatch(getServiceGroupGetSuperUserRelation(null, userSecernId));
    dispatch(modalActions.hideModal());
  };
}
